module.exports = __webpack_public_path__ + "img/6.e9f691d8.png";